import { render, staticRenderFns } from "./recados_vendedor.vue?vue&type=template&id=ba1e00f4&scoped=true&"
import script from "./recados_vendedor.vue?vue&type=script&lang=js&"
export * from "./recados_vendedor.vue?vue&type=script&lang=js&"
import style0 from "./recados_vendedor.vue?vue&type=style&index=0&id=ba1e00f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1e00f4",
  null
  
)

export default component.exports